import React from 'react';
import Header from '@/components/common/Header';
import { useCompanyDispatches } from '@/hooks/useCompanyDispatches';
import { useGetCustomers } from '@/api/hooks/useGetCustomers';
import { ActiveServiceCallsTable } from '@/components/ActiveServiceCallsTable';
import { Loader2, AlertCircle } from 'lucide-react';

interface AllDispatchScreenProps {
  showHeader?: boolean;
  onCallClick?: (callId: string) => void;
}

const AllDispatchScreen: React.FC<AllDispatchScreenProps> = ({ showHeader = true, onCallClick }) => {
  const { data: dispatches = [], isLoading: dispatchesLoading, error: dispatchesError } = useCompanyDispatches();
  const { data: customersData } = useGetCustomers();

  if (dispatchesLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 size={32} className="animate-spin text-primary" />
      </div>
    );
  }

  if (dispatchesError) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center text-red-600">
          <AlertCircle size={48} className="mx-auto mb-4" />
          <p>Error loading dispatch data</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {showHeader && (
        <Header
          driverName="All Dispatches"
          status="ACTIVE"
          onMenuClick={() => {}}
          onStatusClick={() => {}}
          onStatusChange={() => {}}
          isEmbeddedMode={false}
        />
      )}

      <div className="px-4 py-4">
        <ActiveServiceCallsTable
          dispatches={dispatches}
          customers={customersData?.data}
          showHeader={true}
          onCallClick={onCallClick}
          showCanceledDispatches
        />
      </div>
    </>
  );
};

export default AllDispatchScreen;
